import { Button, Dialog, DialogProps } from '@optimus-web/core';
import { lt } from '@mews/framework';

interface Props extends DialogProps {
    onSuccess: () => void;
}

export const CancelDepositWarningDialog = ({ active, onSuccess, onClose }: Props) => {
    return (
        <Dialog
            data-test-id="cancel-deposit-dialog"
            title={lt('CancelDepositDialogTitle')}
            onClose={onClose}
            active={active}
            footer={{
                primary: (
                    <Button
                        type="button"
                        variant="primary"
                        onClick={(e) => {
                            onSuccess();
                            onClose?.(e);
                        }}
                    >
                        {lt('Confirm')}
                    </Button>
                ),
                secondary: (
                    <Button type="button" onClick={onClose}>
                        {lt('Cancel')}
                    </Button>
                ),
            }}
        >
            {lt('CancelDepositDialogContent')}
        </Dialog>
    );
};
